<template>
  <div>
    <v-col cols="12" class="text-center">
      <h3 class="mb-4">¿Está seguro de que desea cancelar el arma a este personal?</h3>
      <TextButton @click="confirmCancel"> Confirmar </TextButton>
    </v-col>
  </div>
</template>

<script>
import TextButton from '@/components/base/TextButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types'

export default {
  name: 'MensajeConfirmacionListaArmasDialogComponent',
  components: { TextButton },
  data() {
    return {
      DIALOG_TYPES,
    }
  },

  props: {
    dialog: { type: Boolean, default: false },
    armaPersonal: { type: Object, required: true },
    onConfirmCancel: { type: Function, required: true },
  },
  methods: {
    confirmCancel() {
      this.onConfirmCancel()
    },
  },
}
</script>
